import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import get from 'lodash/get';

const CustomModal = ({ ...props }) => {
  const { show, hideModal, showCloseButton, size = '', onOk, onCancel, okLabel = 'OK', cancelLabel = 'Cancel', closeOnOk = true, dialogClassName = 'custom-modal', okBtnClassVal = '' } = props;
  const title = get(props, 'title', '');
  const body = get(props, 'body', '');

  return <Modal centered show={show} onHide={hideModal} autoFocus size={size} dialogClassName={dialogClassName}>
    {
      title && <Modal.Header closeButton={showCloseButton}>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
    }
    <Modal.Body>
      {body}
    </Modal.Body>
    {
      (onOk || onCancel) && <Modal.Footer>
        {
          onCancel && <button onClick={() => { hideModal(); onCancel(); }}
            className='btn btn-link text-muted'
          >{cancelLabel}</button>
        }
        {
          onOk && <button onClick={() => { closeOnOk && hideModal(); onOk(); }}
            className={okBtnClassVal}
          >{okLabel}</button>
        }
      </Modal.Footer>
    }
  </Modal>;
};

CustomModal.propTypes = {
  show: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  showCloseButton: PropTypes.bool,
  children: PropTypes.node,
  size: PropTypes.string,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  closeOnOk: PropTypes.bool,
  dialogClassName: PropTypes.string,
  okBtnClassVal: PropTypes.string
};

export default React.memo(CustomModal);
